import { SentryCommonConfig } from 'lib/sentry';
import ReactDOM from 'react-dom/client';
import { App } from './App';

SentryCommonConfig();

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(<App />);
